document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('country-selector-trigger');
    const popup = document.getElementById('language-popup');
    const overlay = document.getElementById('overlay');
    const euLink = document.getElementById('eu-language-link');
    const euContainers = document.querySelectorAll('.eu-language-link-container');
    const twoStepContainer = document.getElementById('two-step-language-list-container');

    if (trigger) {
      trigger.addEventListener('click', function () {
        popup.classList.toggle('active');
        overlay.classList.toggle('active');
        document.body.style.overflow = popup.classList.contains('active') ? 'hidden' : 'auto';
        resetLanguageLinks();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        popup.classList.remove('active');
        overlay.classList.remove('active');
        document.body.style.overflow = 'auto';
        resetLanguageLinks();
      });
    }

    if (euLink && euContainers.length && twoStepContainer) {
      euLink.addEventListener('click', function () {
        twoStepContainer.classList.add('eu-hidden');
        twoStepContainer.classList.remove('eu-visible');

        euContainers.forEach(container => {
          container.classList.remove('eu-hidden');
          container.classList.add('eu-visible');
        });
      });
    }

    const resetLanguageLinks = () => {
      setTimeout(() => {
        twoStepContainer.classList.remove('eu-hidden');
        twoStepContainer.classList.add('eu-visible');

        euContainers.forEach(container => {
          container.classList.remove('eu-visible');
          container.classList.add('eu-hidden');
        });
      }, 300);
    }
  });